/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCreateTask = /* GraphQL */ `
  subscription OnCreateTask {
    onCreateTask {
      User
      TaskName
      Description
      DateCreated
      TaskRunTime
      TaskStatus
    }
  }
`;
export const onDeleteTask = /* GraphQL */ `
  subscription OnDeleteTask {
    onDeleteTask {
      User
      TaskName
      Description
      DateCreated
      TaskRunTime
      TaskStatus
    }
  }
`;
export const onUpdateTaskStatus = /* GraphQL */ `
  subscription OnUpdateTaskStatus {
    onUpdateTaskStatus {
      User
      TaskName
      Description
      DateCreated
      TaskRunTime
      TaskStatus
    }
  }
`;
